var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { lg: "6", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Invoice No.",
                  value: _vm.invoiceNo || "N/A",
                  "error-messages": _vm.errors.id || [],
                  disabled: ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "6", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Invoice Date",
                  type: "date",
                  value: _vm.invoiceDate,
                  "error-messages": _vm.errors.invoice_date || []
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "6", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Due Date",
                  type: "date",
                  "error-messages": _vm.errors.due_date || []
                },
                model: {
                  value: _vm.dueDate,
                  callback: function($$v) {
                    _vm.dueDate = $$v
                  },
                  expression: "dueDate"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "6", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Amount Due",
                  value: _vm.amountDue.phpFormat(),
                  "error-messages": _vm.errors.amount_due || [],
                  readonly: ""
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }